<div class="need-help">
  <h2 class="mb-4">
    <ng-container i18n="@@NeedHelp.NeedAssistance">Need Assistance</ng-container>
    ?
  </h2>
  <div class="details">
    <div class="detail whatsapp" *ngIf="contactInfo.whatsapp">
      <fa-icon xIconSize="large" icon="whatsapp"></fa-icon>
      <span>
        For real-time assistance, WhatsApp us on
        <a mat-button xButtonType="text" target="_blank" [href]="contactInfo.whatsapp.link">
          {{ contactInfo.whatsapp.number }}
        </a>
      </span>
    </div>

    <div class="detail phone-number">
      <fa-icon xIconSize="large" icon="phone"></fa-icon>
      <span>
        Call
        <a mat-button xButtonType="text" [href]="'tel:' + contactInfo.phone | removeSpaces">
          {{ contactInfo.phone }}
        </a>
      </span>
    </div>

    <div class="detail email">
      <fa-icon icon="envelope" xIconSize="large"></fa-icon>
      <a mat-button xButtonType="text" [href]="'mailto:' + contactInfo.email">
        {{ contactInfo.email }}
      </a>
    </div>

    <div class="detail fresh-chat" *ngIf="enableChat">
      <fa-icon icon="message" xIconSize="large"></fa-icon>
      <div class="msg">
        <a mat-button xButtonType="text" (click)="showChat()" i18n="@@CallToAction.SendUsAMessage">
          Send us a message
        </a>
        <ng-container i18n="@@Note.RealTimeAssistance">
          for real-time assistance using the blue live chat button.
        </ng-container>
      </div>
    </div>
  </div>

  <div class="help-time mt-4">
    {{ contactInfo.availability }}
  </div>
</div>
